/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CarrierType {
  INTRA_STATE = 'intra_state',
  INTER_STATE_UCR = 'inter_state_ucr',
}
